var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11505.356 755 28.429 28.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a1e1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11505.356 755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M616.914,0a14.214,14.214,0,1,0,14.214,14.214A14.228,14.228,0,0,0,616.914,0Zm0,26.892a12.679,12.679,0,1,1,12.678-12.678,12.635,12.635,0,0,1-12.678,12.678Zm0,0",
    transform: "translate(-602.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M672.673,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0",
    transform: "translate(-661.568 -69.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M751.873,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0",
    transform: "translate(-731.26 -69.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M666.519,148.274a8.929,8.929,0,0,0,7.455-4.046l-1.3-.828a7.317,7.317,0,0,1-12.281,0l-1.3.828a8.929,8.929,0,0,0,6.4,3.986,10.087,10.087,0,0,0,1.02.06Zm0,0",
    transform: "translate(-652.329 -126.184)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyIcon);
export default __webpack_public_path__ + "static/media/happy_icon.d4ac52410181abe89b159744e0468d99.svg";
export { ForwardRef as ReactComponent };